import React, { useContext, useState } from 'react';
import {NavLink } from 'react-router-dom';
import logo from '../../../assets/img/logo.webp'
import { AuthContext } from '../../../Context/AuthProvider/AuthProvider';
export const Header = () => {
    const { logout, user } = useContext(AuthContext)
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const handleLogOut = () => {
        logout()
            .then(() => { })
            .catch(error => console.error(error.message))
    }
    return (
        <div className="bg-slate-5">
            <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-0">
                <div className="relative flex items-center justify-between">
                    <NavLink
                        to="/"
                        aria-label="Company"
                        title="Company"
                        className="inline-flex items-center"
                    >
                        <span><img src={logo} alt="" /></span>
                        <span className="ml-1 text-sm font-bold tracking-wide camelcase">
                            Artsy Lens
                        </span>
                    </NavLink>
                    <ul className="flex items-center hidden space-x-8 lg:flex">
                        <li>
                            <NavLink to="/"
                                aria-label="Our product"
                                title="Our product"
                                className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                            >
                                Home
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/blogs"
                                aria-label="Product pricing"
                                title="Product pricing"
                                className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                            >
                                Blog
                            </NavLink>
                        </li>
                        {
                            user?.email ?
                                <>
                                    <li>
                                        <NavLink to='/myreview'
                                            aria-label="Product pricing"
                                            title="Product pricing"
                                            className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                                        >
                                            My Reviews
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to='/addservice'
                                            aria-label="Product pricing"
                                            title="Product pricing"
                                            className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                                        >
                                            Add Services
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink onClick={handleLogOut}
                                            aria-label="Product pricing"
                                            title="Product pricing"
                                            className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                                        >
                                            Logout
                                        </NavLink>
                                    </li>
                                </>
                                :
                                <>
                                    <li>
                                        <NavLink to="/login"
                                            aria-label="Product pricing"
                                            title="Product pricing"
                                            className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                                        >
                                            Login
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/signup"
                                            aria-label="Product pricing"
                                            title="Product pricing"
                                            className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                                        >
                                            Signup
                                        </NavLink>
                                    </li>
                                </>
                        }

                    </ul>
                    <div className="lg:hidden">
                        <button
                            aria-label="Open Menu"
                            title="Open Menu"
                            className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline"
                            onClick={() => setIsMenuOpen(true)}
                        >
                            <svg className="w-5 text-black text-lg  " viewBox="0 0 24 24">
                                <path
                                    fill="currentColor"
                                    d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                                />
                                <path
                                    fill="currentColor"
                                    d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                                />
                                <path
                                    fill="currentColor"
                                    d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                                />
                            </svg>
                        </button>
                        {isMenuOpen && (
                            <div style={{ zIndex: '1' }} className="absolute top-0 left-0 w-full">
                                <div className="p-5 bg-white border rounded shadow-sm">
                                    <div className="flex items-center justify-between mb-4">
                                        <div>
                                            <NavLink
                                                to="/"
                                                aria-label="Company"
                                                title="Company"
                                                className="inline-flex items-center"
                                            >
                                                <span><img src={logo} alt="" /></span>
                                                <span className="ml-1 text-sm font-bold tracking-wide camelcase">
                                                    Artsy Lens
                                                </span>
                                            </NavLink>
                                        </div>
                                        <div>
                                            <button
                                                aria-label="Close Menu"
                                                title="Close Menu"
                                                className="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                                                onClick={() => setIsMenuOpen(false)}
                                            >
                                                <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                                                    <path
                                                        fill="currentColor"
                                                        d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                                                    />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <nav>
                                        <ul className="space-y-4">
                                            <li>
                                                <NavLink
                                                    to="/"
                                                    aria-label="Our product"
                                                    title="Our product"
                                                    className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                                >
                                                    Home
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    to="/blogs"
                                                    aria-label="Our product"
                                                    title="Our product"
                                                    className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                                                >
                                                    Blog
                                                </NavLink>
                                            </li>

                                            {
                                                user?.email ?
                                                    <>
                                                        <li>
                                                            <NavLink to='/myreview'
                                                                aria-label="Product pricing"
                                                                title="Product pricing"
                                                                className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                                                            >
                                                                My Reviews
                                                            </NavLink>
                                                        </li>
                                                        <li>
                                                            <NavLink to='/addservice'
                                                                aria-label="Product pricing"
                                                                title="Product pricing"
                                                                className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                                                            >
                                                                Add Services
                                                            </NavLink>
                                                        </li>
                                                        <li>
                                                            <NavLink onClick={handleLogOut}
                                                                aria-label="Product pricing"
                                                                title="Product pricing"
                                                                className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                                                            >
                                                                Logout
                                                            </NavLink>
                                                        </li>
                                                    </>
                                                    :
                                                    <>
                                                        <li>
                                                            <NavLink to="/login"
                                                                aria-label="Product pricing"
                                                                title="Product pricing"
                                                                className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                                                            >
                                                                Login
                                                            </NavLink>
                                                        </li>
                                                        <li>
                                                            <NavLink to="/signup"
                                                                aria-label="Product pricing"
                                                                title="Product pricing"
                                                                className="text-black font-medium tracking-wide transition-colors duration-200 hover:text-teal-accent-400"
                                                            >
                                                                Signup
                                                            </NavLink>
                                                        </li>
                                                    </>
                                            }

                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;